module.exports = __webpack_public_path__ + "img/educationalTraining1.4362f55d.png";